import { keyframes } from '@emotion/react';
const initTheme = {
  // Font-family
  fontRoboto: 'Roboto',

  //Animation define
  fadeIn: keyframes`
    0% {
      opacity: 0;
    }
    100% {
      opacity: 1;
    }
  `,
  fadeOut: keyframes`
    0% {
      opacity: 1;
    }
    100% {
      opacity: 0;
    }
  `,
  unfoldIn: keyframes`
    0% {
      transform: scaleY(.005) scaleX(0);
    }
    50% {
      transform: scaleY(.005) scaleX(1);
    }
    100% {
      transform: scaleY(1) scaleX(1);
    }
  `,
  unfoldOut: keyframes`
    0% {
      transform: scaleY(1) scaleX(1);
    }
    50% {
      transform: scaleY(.005) scaleX(1);
    }
    100% {
      transform: scaleY(.005) scaleX(0);
    }
  `,
  zoomIn: keyframes`
    0% {
      transform: scale(0);
    }
    100% {
      transform: scale(1);
    }
  `,
  zoomOut: keyframes`
    0% {
      transform: scale(1);
    }
    100% {
      transform: scale(0);
    }
  `,
  roadRunnerIn: keyframes`
    0% {
      transform:translateX(-1500px) skewX(30deg) scaleX(1.3);
    }
    70% {
      transform:translateX(30px) skewX(0deg) scaleX(.9);
    }
    100% {
      transform:translateX(0px) skewX(0deg) scaleX(1);
    }
  `,
  roadRunnerOut: keyframes`
    0% {
      transform:translateX(0px) skewX(0deg) scaleX(1);
    }
    30% {
      transform:translateX(-30px) skewX(-5deg) scaleX(.9);
    }
    100% {
      transform:translateX(1500px) skewX(30deg) scaleX(1.3);
    }
  `,

};

const light = {
  ...initTheme,
  name: 'light',
  $dark: '#000000',
  $white: '#FFFFFF',
  $gray: '#F3F3F3',
  $grayShadow: '#4A4A4A',

  palette: {
    mode: "light",
    default: {
      main: "#000000",
      contrastText: "#ffffff",
    },
    primary: {
      main: "#ffffff",
      contrastText: "#000000",
    },
    text: {
      primary: "#000000",
      secondary: "#4B4B4B",
    },
    background: {
      paper: "#ffffff",
      default: "#ffffff",
      customizedProcessing: "#F3F3F3"
    },
    divider: "#000000",
    action: {
      hover: "rgba(0, 0, 0, 0.04)",
    },
  },
  bodyModal: {
    popupBoxBackground: "#00000050",
  }
};

const dark = {
  ...initTheme,
  palette: {
    mode: "dark",
    default: {
      main: "#ffffff",
      contrastText: "#000000",
    },
    primary: {
      main: "#000000",
      contrastText: "#ffffff",
    },
    text: {
      primary: "#ffffff",
      secondary: "#ffffffb3"
    },
    background: {
      paper: "#000000",
      default: "#000000",
      customizedProcessing: "#0C0C0C"
    },
    divider: "#ffffff",
    action: {
      hover: "rgba(255, 255, 255, 0.08)",
    },
  },
  customShadows: {
    footer: "0px 8px 10px -5px rgb(74 74 74), 0px 16px 24px 2px rgb(74 74 74), 0px 6px 30px 5px rgb(74 74 74)",
  },
  bodyModal: {
    popupBoxBackground: "#0C0C0C",
  }
};

export const themes = {
  light,
  dark,
};

export const defaultTheme = 'light';


export const customDesktop = (props) => `
  .box-extend{
    margin-bottom: 22px;
    width: 360px;
    height: 608px;
    position: relative;
    border-radius: 8px;
    box-shadow: 0 8px 16px 0 rgb(0 0 0 / 20%);
    overflow: hidden;
    background: ${props.theme.palette.background.default};
  }
`;
export const customMobile = `
  .box-extend{
     width: 100%;
     height: 100%;
  }
`;
